<template>
  <div class="submission-status-cards-container is-hidden-touch is-hidden-desktop-only" :class="{ 'is-IE': isIE11 }">
    <div ref="cardsContainer" class="submission-cards" @scroll="handleScroll">
      <submission-status v-for="submission in this.submissions"
                         :ref="`status${submission.fair.id}`"
                         :submission="submission"
                         :key="submission.fair.slug"
                         :isSnapshot="isSnapshot"
                         @confirmApproval="confirmApproval"
                         @reasonDenial="reasonDenial" >
      </submission-status>
    </div>
  </div>
</template>

<script>
import userAgent from '@/libs/user-agent'
import SubmissionStatus from './SubmissionStatus'

export default {
  components: {
    SubmissionStatus
  },
  props: ['submissions', 'isSnapshot', 'confirmModal'],
  computed: {
    isIE11: function () {
      return userAgent.isIE11()
    }
  },
  methods: {
    handleScroll: function (el) {
      if (el.srcElement.scrollTop > 1) {
        this.showUp = true
      } else {
        this.showUp = false
      }
      if ((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
        this.showDown = false
      } else {
        this.showDown = true
      }
    },
    confirmApproval: function (event) {
      this.$emit('confirmApproval', event)
    },
    reasonDenial: function (event) {
      this.$emit('reasonDenial', event)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.submission-status-cards-container {
  margin: 0 0 1rem 1rem;
}

.submission-cards {
  overflow: visible;
  scroll-behavior: smooth;
}

.is-IE {
  right: calc(100vw/2 - 400px - 200px - 16px);
}

</style>
